export const BannerSelect = [
  { label: 'Angular', value: '1' },
  { label: 'Node Js', value: '2' },
  { label: 'React', value: '3' },
  { label: 'Python', value: '3' },
]
export const BannerSelectfour = [
  { label: 'Development', value: '1' },
  { label: 'Marketing', value: '2' },
]
export const CourseCategory = [
  { label: 'Management', value: '1' },
  { label: 'IT & Softwares', value: '2' },
  { label: 'Marketing', value: '3' },
  { label: 'Finance', value: '4' },
  { label: 'Productivity', value: '5' },
]
export const CourseLevel = [
  { label: 'Beginner', value: '1' },
  { label: 'Intermediate', value: '2' },
  { label: 'Advanced', value: '3' },
  { label: 'Expert', value: '4' },
]
export const Language = [
  { label: 'French', value: '1' },
  { label: 'German', value: '2' },
  { label: 'Arabic', value: '3' },
]
export const PrivateCourse = [
  { label: 'Private', value: '1' },
  { label: 'Public', value: '2' },
]
export const CourseVideo = [
  { label: 'External URL', value: '1' },
  { label: 'Youtube', value: '2' },
  { label: 'External', value: '3' },
  { label: 'Vimeo', value: '4' },
]
export const Category = [
  { label: 'Mailing Issues', value: '1' },
  { label: 'Language Issues', value: '2' },
  { label: 'Installation Error', value: '3' },
]
export const Priority = [
  { label: 'High', value: '1' },
  { label: 'Low', value: '2' },
  { label: 'Medium', value: '3' },
]
export const Gender = [
  { label: 'Laki-laki', value: 'male' },
  { label: 'Perempuan', value: 'female' },
]
export const Country = [
  { label: 'United states of America', value: '1' },
  { label: 'Canada', value: '2' },
  { label: 'Germany', value: '3' },
]
export const State = [
  { label: 'California', value: '1' },
  { label: 'New York', value: '2' },
  { label: 'Texas', value: '3' },
]
export const City = [
  { label: 'Los Angeles', value: '1' },
  { label: 'San Diego', value: '2' },
  { label: 'Fresno', value: '3' },
]
export const Payment_Method = [
  { label: 'Credit Card', value: '1' },
  { label: 'Debit Card', value: '2' },
  { label: 'Paypal', value: '3' },
  { label: 'Stripe', value: '4' },
]

export const Role_Option = [
  { value: 'admin', label: 'Admin' },
  { value: 'supervisor', label: 'Supervisor' },
  { value: 'user', label: 'User' },
]
